/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { uid } from 'react-uid';

// Material UI
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// Helper
import * as CalendarUtility from './helpers/calendarUtility';

const styles = (theme) => ({
    monthHeader: {
        fontFamily: theme.fontFamily,
        fontSize: '1em',
        fontWeight: '600',
        margin: '10px 0',
        color: theme.palette.unSelectedDeliveryDay || '000',
    },
    weekHeader: {
        fontFamily: theme.fontFamily,
        fontWeight: '600',
        marginBottom: '10px',
        color: theme.palette.unSelectedDeliveryDay || '000',
    },
    dayOfTheWeek: {
        margin: '3px 0px',
    },
    selectedBtn: {
        backgroundColor: '#7ed0b1',
    },
    container: {
        borderBottom: `1px solid ${(theme.palette.primary?.[200] || '#d5d5d5')}`,
    },
    [theme.breakpoints.only('xs')]: {
        monthHeader: {
            display: 'flex',
            textAlign: 'center',
            justifyContent: 'center',
        },
    },
    [theme.breakpoints.up('sm')]: {
        container: {
            border: `1px solid ${(theme.palette.primary?.[200] || '#d5d5d5')}`,
        },
        alignIcon: {
            display: 'inline-block',
            alignItems: 'center',
            padding: '0px',
            '& svg': {
                color: (theme.palette.primary?.main || '#2f2f2f'),
            },
        },
        iconText: {
            fontSize: '1em',
            fontWeight: '600',
        },
        headerContainer: {
            textAlign: 'center',
            backgroundColor: (theme.palette.primary?.[200] || '#d5d5d5'),
            padding: '6px 15px',
            // textTransform: 'uppercase',
            marginBottom: '10px',
        },
        cursorPointer: {
            cursor: 'pointer',
        },
        weekHeader: {
            fontSize: '1em',
        },
        deliveryDateContainer: {
            margin: '0 10px',
        },
        deliveryDayContainer: {
            border: `1px solid ${(theme.palette.primary?.[200] || '#d5d5d5')}`,
            margin: '2px',
        },
        deliveryDisableDay: {
            border: `1px solid ${theme.palette.common?.white || '#ffffff'}`,
            margin: '2px',
        },
    },
});

class Calendar extends Component {
    showDayOfTheWeekHeader = () => {
        const { classes, getMediumDayFormat } = this.props;
        return CalendarUtility.DaysOfTheWeekShort.map((day, indexDay) => (
            <Grid item xs align="center" key={uid(day, indexDay)}>
                <Typography className={classes.weekHeader}>
                    {(getMediumDayFormat) ? day : day[0]}
                </Typography>
            </Grid>
        ));
    }

    showDaysOfTheWeek = (daysData) => CalendarUtility.DaysOfTheWeekShort.map((day, index) => this.showDay(daysData[index], index))

    showWeeksOfTheMonth = (weeksData) => {
        const Weeks = Object.keys(weeksData);
        return Weeks.map((week, index) => {
            const keyWeek = `week${index}`;
            return (
                <Grid key={keyWeek} container direction="row" spacing={0} style={{ marginBottom: '4px' }}>
                    {this.showDaysOfTheWeek(weeksData[week])}
                </Grid>
            );
        });
    }

    showPrev = (month) => {
        const currentDate = new Date();
        const {
            showNavBtnFrYear, year, showNavBtnFrMonth, onClickCalPrev, classes, getIconPlaceholder,
        } = this.props;
        if (showNavBtnFrYear === year && showNavBtnFrMonth === month && (currentDate.getFullYear() !== parseInt(year, 10) || (parseInt(month, 10) !== currentDate.getMonth() + 1))) {
            return (
                <>
                    <IconButton
                        aria-label="Previous Month"
                        onClick={onClickCalPrev}
                        className={classes.alignIcon}
                        data-test="checkout-delivery-calendar-next-previous-button"
                    >
                        <ChevronLeft />
                    </IconButton>
                    {(getIconPlaceholder)
                        && (
                            <Typography
                                variant="caption"
                                className={classes.iconText}
                                onClick={onClickCalPrev}
                            >
                                Prev
                            </Typography>
                        )}
                </>
            );
        }
        return null;
    }

    showNext = (month) => {
        const {
            showNavBtnFrYear, year, showNavBtnFrMonth, onClickCalNext, classes, getIconPlaceholder,
        } = this.props;
        console.log('month', month, showNavBtnFrYear, year, showNavBtnFrMonth, month);
        if (showNavBtnFrYear === year && showNavBtnFrMonth === month) {
            return (
                <>
                    {(getIconPlaceholder)
                        && (
                            <Typography
                                variant="caption"
                                className={classes.iconText}
                                onClick={onClickCalNext}
                            >
                                Next
                            </Typography>
                        )}
                    <IconButton
                        aria-label="Next Month"
                        onClick={onClickCalNext}
                        data-test="checkout-delivery-calendar-next-month-button"    // do NOT change or remove data-test attribute
                        className={classes.alignIcon}
                    >
                        <ChevronRight />
                    </IconButton>
                </>
            );
        }

        return null;
    }

    showMonths = (MonthsData) => {
        const Months = Object.keys(MonthsData).sort();
        const { classes, year } = this.props;
        return Months.map((month, indexMonth) => {
            const keyMonth = `month${indexMonth}`;
            const nameOfTheMonth = CalendarUtility.MonthsFull[parseInt(month, 10) - 1];
            return (
                <Grid key={keyMonth} container className={classes.container}>
                    <Grid item xs={12}>
                        <Grid container className={classes.headerContainer}>
                            <Grid item xs={2} align="left" className={classes.cursorPointer}>
                                {this.showPrev(month)}
                            </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    className={classes.monthHeader}
                                    align="center"
                                    variant="body2"
                                    component="span"
                                >
                                    {`${nameOfTheMonth} ${year}`}
                                </Typography>
                            </Grid>
                            <Grid item xs={2} align="right" className={classes.cursorPointer}>
                                {this.showNext(month)}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className={classes.deliveryDateContainer}>
                        <Grid container>
                            <Grid item xs={12}>
                                <Grid container>
                                    {this.showDayOfTheWeekHeader()}
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container>
                                    {this.showWeeksOfTheMonth(MonthsData[month])}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            );
        });
    }

    showDay(day, index) {
        const {
            overWriteDateComponent, selectedDates, onSelectedDate, classes,
        } = this.props;
        if (overWriteDateComponent) {
            return overWriteDateComponent(day, selectedDates, onSelectedDate, index, {
                root: classes.deliveryDayContainer,
                disable: classes.deliveryDisableDay,
            });
        }
        if (day) {
            const markAsSelected = (selectedDates.indexOf(day.date) >= 0) ? styles.selectedBtn : {};
            return (
                <Typography key={uid(day, index)} style={styles.dayOfTheWeek}>
                    <Button style={markAsSelected} onClick={() => { onSelectedDate(day.dateObj); }}>
                        {day.dateObj.getDate()}
                    </Button>
                </Typography>
            );
        }
        return (
            <Typography key={uid(day, index)} style={styles.dayOfTheWeek}>
                <Button disabled />
            </Typography>
        );
    }

    render() {
        const { calendarData, year } = this.props;
        return (
            <Grid>
                {this.showMonths(calendarData[year])}
            </Grid>
        );
    }
}

Calendar.propTypes = {
    calendarData: PropTypes.object.isRequired,
    year: PropTypes.string.isRequired,
    onClickCalNext: PropTypes.func.isRequired,
    onClickCalPrev: PropTypes.func.isRequired,
    showNavBtnFrYear: PropTypes.string.isRequired,
    showNavBtnFrMonth: PropTypes.string.isRequired,
    selectedDates: PropTypes.array.isRequired,
    overWriteDateComponent: PropTypes.func.isRequired,
    onSelectedDate: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    getMediumDayFormat: PropTypes.bool,
    getIconPlaceholder: PropTypes.bool,
};

Calendar.defaultProps = {
    getMediumDayFormat: false,
    getIconPlaceholder: false,
};

export default withStyles(styles)(Calendar);
